module.exports = __webpack_public_path__ + "img/proj_interpret.0aaf0ce5.gif";